import { Injectable } from '@angular/core';

import { ApiService, GlobalVar } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class AssignmentService {

  constructor(
    public globalvar: GlobalVar,
    public apiService: ApiService,
  ) { }

  post(body) {

  }

  put(body) {
    body.user_id = this.globalvar._user.id;
    return this.apiService.post(this.globalvar._putAssignment, body);
  }

  get() {

  }

  getAll() {
    return this.apiService.get(this.globalvar._getAssignments);
  }
}
